var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.167 3.117L10.883.833A1.667 1.667 0 008.667.775l-7.5 7.5c-.27.272-.437.628-.475 1.008l-.359 3.475a.834.834 0 00.834.909h.075l3.475-.317c.38-.038.736-.206 1.008-.475l7.5-7.5a1.6 1.6 0 00-.058-2.258zm-8.6 8.566l-2.5.234.225-2.5L7 4.767l2.25 2.25-4.683 4.666zM10.333 5.9L8.1 3.667 9.725 2 12 4.275 10.333 5.9z",
    fill: "#8092AC"
  })));
}

export default SvgEdit;